(function() { window.GUID_1b87502a_0908_423b_a5f1_cd5aa007f514 = { getGuid: function() { return "1b87502a-0908-423b-a5f1-cd5aa007f514"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class GaugeChart extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                const me = this;
            }
            OnBindEvents() {
            }
            OnDispose() {
            }
        }
        Controls.GaugeChart = GaugeChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=gauge-chart.js.map
